import styled from 'styled-components';

export const AllNFTSContainer = styled.section`
  grid-area: allNFTS;
`;
